import replaceCallbackInterruptions from './replace-callback-interruptions';

export default {
  replaceCallbackInterruptions,
};
